import React from 'react';

import { Redirect } from '../components/Router';

const UserProfileUnknownRoute = ({ match }: { match: any }) => (
	<Redirect to={match.params.userId} />
);

export default UserProfileUnknownRoute;
